export default __webpack_public_path__ + "static/courageLogo-6ec5dca7ae8319e0a8aece9bb9f1549b.png";